export default __webpack_public_path__ + "static/approaches_we_use-6c4e564778e763c5231575908b1df301.webp";